<template>
  <ExternalList
      endpoint="/api/v2/time-based-ad-locations"
      :endpoint-filters="{time_based_channel_id: timeBasedChannel.id}"
      :headlines=" [{width: 20, text: 'Name'}]"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/time-based-ad-locations/priorities"
      :get-reorder-payload="data => ({time_based_ad_locations: data})"
      @show="edit"
  >
    <template v-slot:default="{ row: timeBasedAdLocation }">
      <td>
        {{ timeBasedAdLocation.attributes.name }}
      </td>
    </template>

    <template v-slot:modals="{ load, update }">
      <CreateModal :timeBasedChannel="timeBasedChannel" @created="load"/>

      <EditModal :time-based-ad-location="editing" @updated="update"/>
    </template>
  </ExternalList>
</template>

<script>
import CreateModal from '../Modals/Create'
import EditModal from '../Modals/Edit'
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {CreateModal, EditModal, ExternalList},

  props: {
    timeBasedChannel: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  methods: {
    edit(timeBasedAdLocation) {
      this.editing = timeBasedAdLocation

      $('#edit-time-based-ad-location-modal').modal('toggle')
    }
  }
}
</script>
